/**
 * reactstrap Modal component stops click event from propagating https://github.com/reactstrap/reactstrap/issues/2158
 * It leads to the problem when element-engagement-handler does not receive click events with React 17+ version.
 * Therefore, tracking of elements which are placed inside the modal component and rely on element-engagement-handler does not work.
 * Stopping mousedown event from propagating does not let Modal window to stop click event internally and fixes tracking problem.
 */
export function modalMousedownTrackingFix(event) {
  event.stopPropagation();
}
